//@ts-check

let inited = false;
let callback = null;

/**
 * 
 * @param {PMRule} rule 
 * @param {() => Promise} cb
 * @param {PromiseConstructor} Promise
 */
module.exports = (rule, cb, Promise) => {
	callback = cb;

	if (!inited) {
		inited = true;

		rule.pm.handleEvent('~.Store_Content', 'inited', (p, widget) => {
			const master_showCbPopup = widget.showCbPopup;
			const master_buyNow = widget.buyNow;

			const promise = new Promise((resolve) => {
				widget.buyNow = (...args) => callback(widget, resolve).then(({ result, params }) => {
					const [arg1, data, ...restArgs] = args;
					if (data) {
						if (result === true) {
							return master_buyNow.apply(widget, [
								arg1,
								{
									...data,
									...params,
								},
								...restArgs
							]);
						}

						return Promise.resolve(result);
					}

					return Promise.resolve(master_buyNow.apply(widget, args));
				});
			})

			widget.showCbPopup = (...args) => promise.then((result) => {
				if (result === true) {
					return master_showCbPopup.apply(widget, args);
				}
			})
		}, {
			sync: true,
			prefix: 'user_access_patch_store_content'
		})
	}
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules/common/patch-store-buy.es.js